import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  viewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import {
  ExpirationType,
  GetPackageSalesForUserDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { PermissionService } from 'src/app/core/services/authentication/permission.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { ApiNotificationService } from '../../../../core/services/api-notification.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-package-organizations-card',
    templateUrl: './package-organizations-card.component.html',
    styleUrls: ['./package-organizations-card.component.scss'],
    imports: [BaseFormModule]
})
export class PackageOrganizationCardComponent
  implements OnInit, OnChanges, AfterViewInit
{
  //#region properties

  @Input() model: GetPackageSalesForUserDto;
  @Input() loading: boolean;
  @Input() parentLoading: boolean;
  buyButtonLoading: boolean;

  @Output() selectedPackageOrganization =
    new EventEmitter<GetPackageSalesForUserDto>();

  readonly discountCode = viewChild<ElementRef>('discountCode');
  readonly discountRow = viewChild<ElementRef>('discountRow');
  readonly submitDiscount = viewChild<ElementRef>('submitDiscount');

  translatedType: string;
  typeName: string;
  discount: number;
  discountPercent: string;
  protected onDestroy$ = new Subject<void>();

  profit: number;

  //#endregion

  constructor(
    public apiNotificationService: ApiNotificationService,
    protected permissionService: PermissionService,
    public dialogService: DialogService,
    private translate: TranslateService,
    protected loggerService: LoggerService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['model']) {
        this.setData(this.model.expirationType);
      }

      if (changes['parentLoading']) {
        const timeOut = setTimeout(() => {
          this.buyButtonLoading = false;
          clearTimeout(timeOut);
        }, 500);
      }
    } catch (error) {
      this.loggerService.logError(
        'app-package-organizations-card',
        error,
        EventTypes.packageOrganization
      );
    }
  }

  ngAfterViewInit(): void {}

  ngOnInit() {
    try {
      this.profit = this.model.depositPrice - this.model.originalPrice;
    } catch (error) {
      this.loggerService.logError(
        'app-package-organizations-card',
        error,
        EventTypes.packageOrganization
      );
    }
  }

  setData(type) {
    try {
      this.translatedType = this.translate.instant(
        'pages.packageOrganizations.expirationTypes.' + type
      );
      this.typeName = this.translate.instant(
        'pages.packageOrganizations.expirationNames.' + type
      );
      this.discount = this.model.depositPrice - this.model.originalPrice;
      this.calculateDiscountPercent();
    } catch (error) {
      this.loggerService.logError(
        'app-package-organizations-card',
        error,
        EventTypes.packageOrganization
      );
    }
  }

  getExpirationTypeHeaderBorderColor(expirationType: ExpirationType) {
    try {
      let classList: string;

      switch (expirationType) {
        case ExpirationType.Hour:
          classList = 'text-orange border-orange';
          break;
        case ExpirationType.Daily:
          classList = 'text-info border-info';
          break;
        case ExpirationType.Weekly:
          classList = 'text-teal border-teal';
          break;
        case ExpirationType.Monthly:
          classList = 'text-rose border-rose';
          break;

        default:
          break;
      }

      return classList;
    } catch (error) {
      this.loggerService.logError(
        'app-package-organizations-card',
        error,
        EventTypes.packageOrganization
      );
    }
  }

  calculateDiscountPercent() {
    try {
      this.discountPercent =
        (100 - (this.model.originalPrice / this.model.depositPrice) * 100)
          .toFixed(0)
          .toString() + '%';
    } catch (error) {
      this.loggerService.logError(
        'app-package-organizations-card',
        error,
        EventTypes.packageOrganization
      );
    }
  }

  onEmitSelectedPackageOrganization() {
    if (this.buyButtonLoading) return;
    this.buyButtonLoading = true;
    this.selectedPackageOrganization.emit(this.model);
  }
}
